import session from './session';

const TIMEOUT_MS = 200000;

export default {
    getAvailableLocations() {
        return session.get('/api/get_location/', { timeout: 5000 } );
    },
};


// WEBPACK FOOTER //
// ./src/api/locations.js